module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modal-title": 'Edit Route'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": _vm.close
    }
  }, [_c('FormulateForm', [_c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Name",
      "validation": "required"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.integrationOptions,
      "label": "Integration",
      "validation": "required"
    },
    model: {
      value: (_vm.model.integration),
      callback: function($$v) {
        _vm.$set(_vm.model, "integration", $$v)
      },
      expression: "model.integration"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "label": "Active"
    },
    model: {
      value: (_vm.model.active),
      callback: function($$v) {
        _vm.$set(_vm.model, "active", $$v)
      },
      expression: "model.active"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57d18622"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/RouteModal.vue
// module id = 645
// module chunks = 0